import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAlertsOutlined = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6.124 3.077h5.372c.178 0 .38 0 .557.018.212.022.472.076.733.238.26.16.425.369.54.549.096.15.186.331.265.49l.014.028.612 1.224.095.188h6.919c.131 0 .317 0 .481.022.207.028.525.107.797.38.273.272.351.59.38.796.021.165.021.35.02.482v9.635c.001.132.001.317-.02.481a1.36 1.36 0 0 1-.38.797c-.272.273-.59.352-.797.38-.164.021-.35.021-.481.021h-6.74c-.177 0-.38 0-.557-.018a1.7 1.7 0 0 1-.732-.237 1.7 1.7 0 0 1-.54-.55c-.096-.15-.186-.33-.266-.49l-.014-.028-.611-1.223-.096-.189H6.497v7.18a1.026 1.026 0 0 1-2.052 0V4.757c0-.132 0-.318.022-.482.028-.207.107-.525.38-.797.272-.273.59-.351.796-.38.164-.021.35-.021.481-.02Zm.373 10.942h4.999c.178 0 .38 0 .557.018.212.022.472.076.733.237.26.162.425.37.54.55.096.15.186.331.265.49l.014.028.612 1.223.095.189h6.546v-8.89h-6.367c-.177 0-.38 0-.557-.018a1.7 1.7 0 0 1-.732-.237 1.7 1.7 0 0 1-.54-.55c-.096-.15-.186-.33-.266-.49l-.014-.028-.611-1.223-.096-.188-.21-.001H6.497z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgAlertsOutlined;
